export var NativeScript = `
<script type="text/javascript">
(function(w, d) {
    function onClose(ev) {
        w.location.href = 'branch-cta://cancel';
        ev.preventDefault();
    }
    function onAccept(ev) {
        w.location.href = 'branch-cta://accept';
        ev.preventDefault();
    };
    var btnClose = d.getElementById('branch-banner-close1');
    if (btnClose) {
        btnClose.onclick = onClose;
    }
    var btnClose = d.getElementById('branch-banner-close2');
    if (btnClose) {
        btnClose.onclick = onClose;
    }
    var btnAccept = d.getElementById('branch-mobile-action');
    if (btnAccept) {
        btnAccept.onclick = onAccept
    }
})(window, document);
</script>`;
